import React from 'react';
import classNames from 'classnames';

import { RCIcon, RCIconProps } from '../RCIcon/RCIcon';

interface RCTextWithIconProps extends Pick<RCIconProps, 'icon' | 'title'> {
  /**
   * Text or html (must be inline only, like `<span>` or `<strong>`) to render next to the icon.
   */
  children: React.ReactNode;

  /**
   * Positioning of the icon relative to the text.
   */
  placement?: 'right' | 'left',

  /** Size of the icon. Defaults to current font size. `large` bumps the icon up to 125%. */
  size?: 'default' | 'large',
}

/**
 * Renders an `RCIcon` inline with text, spaced appropriately. Often used within an `RCButton`.
 */
export function RCTextWithIcon({
  icon: iconProp,
  children,
  title = undefined,
  placement = 'right',
  size = 'default',
}: RCTextWithIconProps) {
  const iconClasses = classNames(
    'rc-text-with-icon__icon', {
      'rc-text-with-icon__icon--right': placement === 'right',
      'rc-text-with-icon__icon--left': placement === 'left',
      'rc-text-with-icon__icon--large': size === 'large',
    },
  );

  const icon = (
    <span className={iconClasses}>
      <RCIcon icon={iconProp} title={title} size="inline" />
    </span>
  );
  return (
    <>
      {(placement === 'left') && icon}
      {children}
      {(placement === 'right') && icon}
    </>
  );
}
